/**
 * 프로모션 전용 통합 앵커 모듈 (성능 최적화 및 안정성 보정 버전)
 */
class PromoAnchor {
  constructor(options = {}) {
    this.opt = $.extend({
      wrap: '.promo_anchor_wrap',
      bar: '.promo_anchor_bar',
      btn: '.anchor_btn', // li와 a의 중복 트리거를 막기 위해 순수 버튼/링크 클래스로 단일화
      tab_item: '.tab_item, .tab_lst, li[role="tab"]',
      timer_wrap: '.evt_anchor_timer',
      timer: '.timer_cnt',
      fixed_class: 'is_fixed',
      offset: 0,
      duration: 350
    }, options);

    this.is_click_scrolling = false;
    this._lastActiveIndex = -1; // 불필요한 중복 실행 방지용 캐시
    this.init();
  }

  init() {
    this.$wrap = $(this.opt.wrap).first();
    if (!this.$wrap.length) return;

    this.calc_sticky_top();
    this.bind_events();
    this.bind_scroll();

    // 이미지 및 리소스 로드 완료 후 좌표 정밀 재계산
    $(window).on('load', () => {
      this.calc_sticky_top();
      $(window).trigger('scroll.promo_anchor');
    });

    // 초기 상태 체크
    $(window).trigger('scroll.promo_anchor');
  }

  calc_sticky_top() {
    if (this.$wrap && this.$wrap.length) {
      this.sticky_top = this.$wrap.offset().top;
    }
  }

  get_visible_timer() {
    return this.$wrap.find(this.opt.timer_wrap).find(this.opt.timer).filter(':visible');
  }

  get_sticky_bar() {
    const $visible_outside_bar = this.$wrap.children(this.opt.bar).filter(':visible');
    if ($visible_outside_bar.length) return $visible_outside_bar.first();

    const $visible_timer = this.get_visible_timer();
    if ($visible_timer.length) return $visible_timer.find(this.opt.bar);

    return this.$wrap.find(this.opt.bar).filter(':visible').first();
  }

  get_active_container() {
    const $visible_timer = this.get_visible_timer();
    if ($visible_timer.length) return $visible_timer;

    const $visible_bar = this.$wrap.children(this.opt.bar).filter(':visible');
    return $visible_bar.length ? $visible_bar : this.$wrap;
  }

  set_active_state($container, index, $sticky_bar) {
    if (index < 0) return;

    // 1. 인덱스가 이전과 같으면 반복 실행(Swiper 슬라이드 및 DOM 연산) 중단
    if (this._lastActiveIndex === index) return;
    this._lastActiveIndex = index;

    // 2. 통이미지 인덱스 갱신
    $container.find(this.opt.bar).add($sticky_bar).attr('data_img_index', index);

    // 3. Swiper / 개별 li 탭 active 클래스 처리
    const $tab_items = $container.find(this.opt.tab_item);
    if ($tab_items.length) {
      $tab_items.removeClass('active');
      $tab_items.eq(index).addClass('active');

      // 4. Swiper 인스턴스 자동 슬라이드 이동
      const swiper_el = $container.find('.swiper-container')[0];
      if (swiper_el && swiper_el.swiper) {
        swiper_el.swiper.slideTo(index);
      }
    }
  }

  bind_events() {
    const self = this;

    this.$wrap.on('click', this.opt.btn, function(e) {
      const $btn = $(this);
      const target_selector = $btn.attr('data_anchor') || $btn.attr('data-anchor') || $btn.attr('href') || '';

      // 해시(#)로 시작하는 내부 앵커 타깃일 때만 기본 동작 방지 및 스크롤 실행
      if (!target_selector || target_selector.charAt(0) !== '#') return;
      
      const $target = $(target_selector);
      if (!$target.length) return;

      e.preventDefault();
      self.is_click_scrolling = true;

      const $sticky_bar = self.get_sticky_bar();
      const bar_height = $sticky_bar.outerHeight() || 0;
      const target_top = $target.offset().top - bar_height - self.opt.offset;

      const $container = self.get_active_container();
      
      let index = -1;
      const $tab_items = $container.find(self.opt.tab_item);
      if ($tab_items.length) {
        const $li = $btn.closest(self.opt.tab_item);
        index = $tab_items.index($li);
      } else {
        const $btns = $container.find(self.opt.btn);
        index = $btns.index($btn);
      }

      self.set_active_state($container, index, $sticky_bar);

      $('html, body').stop().animate({
        scrollTop: Math.floor(target_top)
      }, self.opt.duration, () => {
        setTimeout(() => {
          self.is_click_scrolling = false;
        }, 50);
      });
    });
  }

  bind_scroll() {
    const self = this;

    $(window).on('scroll.promo_anchor', () => {
      const scroll_top = $(window).scrollTop();
      const $sticky_bar = self.get_sticky_bar();
      if (!$sticky_bar.length) return;

      const bar_height = $sticky_bar.outerHeight() || 0;

      // 비활성 바의 고정 클래스 제거 (스케줄러 변경 대비)
      self.$wrap.find(self.opt.bar).not($sticky_bar).removeClass(self.opt.fixed_class);

      // 비동기 지연/에러 방어
      if (!$sticky_bar.hasClass(self.opt.fixed_class)) {
        const current_top = Math.floor(self.$wrap.offset().top);
        if (current_top > 50) {
          self.sticky_top = current_top;
        }
      }

      // 스크롤 락
      const is_scrolled_down = scroll_top > 50;

      if (is_scrolled_down && scroll_top >= self.sticky_top - self.opt.offset) {
        if (!$sticky_bar.hasClass(self.opt.fixed_class)) {
          $sticky_bar.addClass(self.opt.fixed_class);
          self.$wrap.css('padding-top', bar_height + 'px');
        }
      } else {
        if ($sticky_bar.hasClass(self.opt.fixed_class)) {
          $sticky_bar.removeClass(self.opt.fixed_class);
          self.$wrap.css('padding-top', '0px');
        }
      }

      if (self.is_click_scrolling) return;

      const $container = self.get_active_container();
      const $tab_items = $container.find(self.opt.tab_item);
      const $targets_to_check = $tab_items.length ? $tab_items.find('a') : $container.find(self.opt.btn);
      if (!$targets_to_check.length) return;

      let active_index = 0;
      $targets_to_check.each(function(idx) {
        const target_selector = $(this).attr('data_anchor') || $(this).attr('data-anchor') || $(this).attr('href') || '';
        if (target_selector.charAt(0) === '#') {
          const $target = $(target_selector);
          if ($target.length) {
            const section_top = $target.offset().top - bar_height - self.opt.offset - 20;
            if (scroll_top >= section_top) {
              active_index = idx;
            }
          }
        }
      });

      self.set_active_state($container, active_index, $sticky_bar);
    });

    $(window).on('resize.promo_anchor orientationchange.promo_anchor', () => {
      this.calc_sticky_top();
    });
  }
}